import { AppLayout } from './components/layout/AppLayout';

export function App() {
  return <AppLayout />;
}
